const getCurrentYear = (globalFilterSeasons) =>
  Number.parseInt(globalFilterSeasons, 10) || new Date().getFullYear();

export default getCurrentYear;
